<template>
  <form @submit.prevent="save"
        class="rename-file">
    <label class="input-cont_small">
      <input v-model="name">
    </label>
    <div class="btns-cont">
      <button type="button"
              @click="cancel"
              class="btn btn-transparent_blue">{{$t('btns.cancel')}}</button>
      <button type="submit"
              :disabled="!name"
              class="btn btn-blue">{{$t('btns.send')}}</button>
    </div>
  </form>
</template>

<script>
  export default {
    name: 'renameFile',
    props: {
      fileName: String
    },
    data() {
      return {
        name: '',
        format: ''
      }
    },
    methods: {
      cancel() {
        this.name = '';
        this.format = '';
        this.$emit('cancel')
      },
      save() {
        this.$emit('save', this.name + this.format);
        this.cancel()
      }
    },
    mounted() {
      let string = this.fileName;
      this.format = string.slice(string.indexOf('.'));

      string = string.slice('', string.indexOf('.'));
      this.name = string
    }
  }

</script>

<style lang="scss" scoped>
.rename-file {
  width: 100%;
  margin-top: 20px;
}

.btns-cont {
  display: flex;
  margin-top: 40px;
  margin-left: -10px;
  margin-right: -10px;
  justify-content: flex-end;

  .btn{
    margin: 0 10px;
    max-width: 170px;
  }
}

  .input-cont_small {
    width: 100%;

    input {
      width: 100%;
    }
  }
</style>
